import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ShowMovieComponent } from '../show-movie/show-movie.component';

@Component({
  selector: 'app-intro-modal',
  templateUrl: './intro-modal.component.html',
  styleUrls: ['./intro-modal.component.scss']
})
export class IntroModalComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<IntroModalComponent>,
    public router: Router,
    // private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data) { }
  video = 'https://www.youtube.com/embed/3YOJvXcINGk';
  videoImg: any;
  videoList = [
    // {
    //   'title' : 'What are Sustainable development goals?',
    //   'videoLink': 'https://www.youtube.com/embed/3YOJvXcINGk'
    // },
    {
      'title': 'Introduction of SDGs',
      'videoLink': 'https://www.youtube.com/embed/RpqVmvMCmp0'
    },
    {
      'title': 'Introduction to Global Classroom',
      'videoLink': 'https://www.youtube.com/embed/X2EwO46wFto'
    }
  ]
  ngOnInit(): void {

    this.videoList.forEach((video: any) => {
      let vt = video.videoLink.split('?');
      video.videoImg = '//i.ytimg.com/vi/' + vt[0].substring(30) + '/hqdefault.jpg';
      video.watched = 0;
    });
  }

  skipIntro() {
    this.dialogRef.close()
    // this.router.navigateByUrl('/');
    // window.location.reload()
  }
  close() {
    this.dialogRef.close()
    // this.router.navigateByUrl('/');
    // window.location.reload()
  }

  watchVideo(video) {
    if (video.videoLink != '') {
      video.watched = 1;
      const dialogRef = this.dialog.open(ShowMovieComponent, {
        disableClose: true,
        width: '800px',
        height: 'auto',

        data: { 'movie': video.videoLink, 'quizVideo': true }
      });
      dialogRef.afterClosed().subscribe(result => {
        // console.log('The dialog was closed', result);
      });
    }
  }

}
